module.exports = __webpack_public_path__ + "img/papcr-link.6dedec0c.png";